import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";
import { Calculator } from "lucide-react";

export function ScoringProperty({
  enabled,
  onChange,
  disabled,
}: {
  enabled: boolean;
  onChange?: (enabled: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      aria-pressed={enabled}
      onClick={() => onChange?.(!enabled)}
      disabled={disabled}
      className={cn(
        "h-7 w-fit gap-1.5 rounded-full px-2 text-xs font-normal hover:text-foreground",
        enabled ? "bg-muted text-foreground" : "text-muted-foreground",
      )}
    >
      <Calculator className="size-3.5" />
      Scoring {enabled ? "on" : "off"}
    </Button>
  );
}
